// WidgetOpcionesValidacionCliente.js
import React, { useState } from "react";
import Swal from "sweetalert2";


const WidgetOpcionesValidacionCliente = (props) => {
  // Definición de los campos disponibles y sus etiquetas
  const availableFields = [
    { key: "direccion", label: "Dirección" },
    { key: "telefono", label: "Teléfono" },
    { key: "email", label: "Email" },
    { key: "nombre_cuenta", label: "Nombre del Cliente" },
  ];

  // Estado local para almacenar los datos ingresados
  const [datos, setDatos] = useState({
    direccion: "",
    telefono: "",
    email: "",
    nombre_cuenta: "",
  });
  // Estado para controlar cuál dato se está ingresando actualmente
  const [currentField, setCurrentField] = useState(null);
  // Estado para el valor ingresado en el input
  const [inputValue, setInputValue] = useState("");

  // Calcula cuáles campos aún no se han completado
  const pendingFields = availableFields.filter(
    (field) => !datos[field.key]
  );

  // Maneja la selección de un campo (al presionar un botón)
  const handleFieldSelect = (fieldKey) => {
    setCurrentField(fieldKey);
    setInputValue("");
  };

  // Actualiza el valor del input
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // Guarda el dato ingresado para el campo actual
  const handleSubmitField = () => {
    if (inputValue.trim() === "") return; // Evitar valores vacíos

    // Validación especial para dirección: se espera "Calle,Numero,Colonia"
    if (currentField === "direccion") {
      const partes = inputValue.split(",");
      if (partes.length < 3) {
         Swal.fire({icon: "error", title: "Error", text: "Formato incorrecto. Usa: Calle,Numero,Colonia"});
         return;
        // alert("Formato incorrecto. Usa: Calle,Numero,Colonia");
        // return;
      }
    }

    // Actualiza el estado con el dato ingresado
    setDatos((prevDatos) => ({
      ...prevDatos,
      [currentField]: inputValue.trim(),
    }));
    setCurrentField(null);
  };

  // Al confirmar, llama a la acción definida en el ActionProvider
  const handleConfirm = () => {
    if (props.actions && props.actions.manejarValidacionCompleta) {
      props.actions.manejarValidacionCompleta(datos);
    }
  };

  // Reinicia el widget en caso de que se desee reiniciar el proceso
  const handleReset = () => {
    setDatos({
      direccion: "",
      telefono: "",
      email: "",
      nombre_cuenta: "",
    });
    setCurrentField(null);
  };

  return (
    <>
      {/* Si aún hay campos pendientes y no se está ingresando ninguno, muestra las opciones */}
      {pendingFields.length > 0 && !currentField && (
        <div className="chat-options-container">
          <p className="react-chatbot-kit-chat-bot-message">
            Selecciona el dato que deseas ingresar:
          </p>
          {pendingFields.map((field) => (
            <button
              key={field.key}
              onClick={() => handleFieldSelect(field.key)}
              className="chat-option-button"
            >
              {field.label}
            </button>
          ))}
        </div>
      )}

      {/* Si se está ingresando un dato, muestra el input */}
      {currentField && (
        <div className="chat-options-container">
          <p className="react-chatbot-kit-chat-bot-message">
            Ingresa{" "}
            {availableFields.find((f) => f.key === currentField).label}:
          </p>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder={
              currentField === "direccion" ? "Calle,Numero,Colonia" : ""
            }
            className="chatbot-input" // Puedes definir esta clase en tu CSS si deseas ajustar el estilo del input
          />
          <button
            onClick={handleSubmitField}
            className="chat-option-button"
          >
            Guardar
          </button>
        </div>
      )}

      {/* Cuando se han completado todos los campos, muestra el resumen y las opciones de confirmación */}
      {pendingFields.length === 0 && !currentField && (
        <div className="chat-options-container">
          <p className="react-chatbot-kit-chat-bot-message">
            Estos son los datos ingresados:
          </p>
          <ul className="react-chatbot-kit-chat-bot-message">
            {availableFields.map((field) => (
              <li key={field.key}>
                <strong>{field.label}:</strong> {datos[field.key]}
              </li>
            ))}
          </ul>
          <p className="react-chatbot-kit-chat-bot-message">
            ¿Deseas confirmar?
          </p>
          <div className="chat-options-container">
            <button
              onClick={handleConfirm}
              className="chat-option-button"
            >
              Sí, confirmar
            </button>
            <button
              onClick={handleReset}
              className="chat-option-button"
            >
              No, reiniciar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WidgetOpcionesValidacionCliente;
